import { render, staticRenderFns } from "./DutyViewFactory.vue?vue&type=template&id=66e8da3d&"
import script from "./DutyViewFactory.vue?vue&type=script&lang=js&"
export * from "./DutyViewFactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports